'use strict';

const calcDuration = (interval) => interval.end - interval.start;

exports.calcDuration = calcDuration;
//# sourceMappingURL=calcDuration.cjs.map
